<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view/>
    <Chatbot/>
  </div>
</template>

<script>
import Chatbot from '@/components/Chatbot.vue';

export default {
  name: 'App',
  components: {
    Chatbot,
  }
}
</script>

<style>
#app {
  background-color: #f2f5e7;
  min-height: 100vh;
}

body {
  background-color: #f2f5e7;
}
/* Fügen Sie hier globale Stile hinzu, falls erforderlich */
</style>
